import { Component } from "../../../components/base/Component";
import { ComponentFactory } from "../../../services/ComponentFactory";
import { ICfa } from "../../../models/ICfa";

export class StillHaveQuestion extends Component {
	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);

		this.applyDatalayerEvent();
	}

	private applyDatalayerEvent(): void {
		const datalayerButtons =
			this._element.querySelectorAll<HTMLElement>("[data-datalayer]");
		const event = {
			eventName: "custom_form_start",
			["form_name"]: "cares_form",
			["form_step"]: "start"
		};
		if (datalayerButtons.length > 0) {
			const key = "optimizely";
			datalayerButtons.forEach((button: HTMLElement) => {
				button.addEventListener("click", e => {
					const href = button.getAttribute("href");
					if (!href) {
						return;
					}
					e.preventDefault();
					(window as any)[key] = (window as any)[key] || [];
					(window as any)[key].push({
						...event,
						["page_url"]: window.location.href
					});
					console.info(`Pushing to data layer: ${JSON.stringify(event)}`);
					window.location.href = href;
				});
			});
		}
	}
}

ComponentFactory.registerComponent("StillHaveQuestion", StillHaveQuestion);
